let rootUrl;
let apiUrl;
let serverUrl;
let therapyUrl;
let stripeKey;
let ENV;
let country;
let oppositeCountryURL;
let ldClientId;
let vonageAppId;
const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
  ENV = 'DEVELOPMENT';
  country = 'CA';
  rootUrl = 'http://localhost:8080';
  apiUrl = 'http://localhost:3000/api';
  serverUrl = 'http://localhost:3000';
  therapyUrl = 'http://localhost:10101';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://portal.inkblotpractice.com';
  ldClientId = '61aa7abf805c8710cfad8b2e';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (
  hostname === 'practice.inkblottherapy.com' ||
  hostname === 'practitioner-stg.greenshieldplus.ca'
) {
  ENV = 'STAGING';
  country = 'CA';
  rootUrl = 'https://practitioner-stg.greenshieldplus.ca';
  apiUrl = 'https://api.inkblottherapy.com/api';
  serverUrl = 'https://api.inkblottherapy.com';
  therapyUrl = 'https://staging.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://us-staging.inkblotpractice.com';
  ldClientId = '61ba3223f940930e6232e840';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (
  hostname === 'practitioner.greenshieldplus.ca' ||
  hostname === 'app.inkblotpractice.com'
) {
  ENV = 'PRODUCTION';
  country = 'CA';
  rootUrl = 'https://practitioner.greenshieldplus.ca';
  apiUrl = 'https://api.inkblotpractice.com/api';
  serverUrl = 'https://api.inkblotpractice.com';
  therapyUrl = 'https://app.inkblottherapy.com';
  stripeKey = 'pk_live_iHFo2C08gcquDQatzHxxOdo9';
  oppositeCountryURL = 'https://portal.inkblotpractice.com';
  ldClientId = '61a4f5fda8e6530f447dbcf9';
  vonageAppId = 'b59dcc83-6621-406c-8b96-17f3fa00951c';
} else if (hostname === 'portal.inkblotpractice.com') {
  ENV = 'US PROD';
  country = 'US';
  rootUrl = 'https://portal.inkblotpractice.com';
  apiUrl = 'https://medapi.inkblottherapy.com/api';
  serverUrl = 'https://medapi.inkblottherapy.com';
  therapyUrl = 'https://portal.inkblottherapy.com';
  stripeKey = 'pk_live_iHFo2C08gcquDQatzHxxOdo9';
  oppositeCountryURL = 'https://practitioner.greenshieldplus.ca';
  ldClientId = '667f146efad7f20fea512899';
  vonageAppId = 'b679910b-d4d7-433c-b84a-7605884310d0';
} else if (hostname === 'us-staging.inkblotpractice.com') {
  ENV = 'US DEV';
  country = 'US';
  rootUrl = 'https://us-staging.inkblotpractice.com';
  apiUrl = 'https://usapi.inkblottherapy.com/api';
  serverUrl = 'https://usapi.inkblottherapy.com';
  therapyUrl = 'https://us-staging.inkblottherapy.com';
  oppositeCountryURL = 'https://practitioner-stg.greenshieldplus.ca';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  ldClientId = '61ba3223f940930e6232e840';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (hostname === 'demo.inkblotpractice.com') {
  ENV = 'DEMO';
  country = 'CA';
  rootUrl = 'https://demo.inkblotpractice.com';
  apiUrl = 'https://demoapi.inkblottherapy.com/api';
  serverUrl = 'https://demoapi.inkblottherapy.com';
  therapyUrl = 'https://demo.inkblottherapy.com';
  stripeKey = 'pk_live_iHFo2C08gcquDQatzHxxOdo9';
  oppositeCountryURL = 'https://demo.inkblotpractice.com';
  ldClientId = '622b6838855e3b14fa2358b2';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (
  hostname === 'qa1-app.inkblotpractice.com' ||
  hostname === 'practitioner-qa.greenshieldplus.ca'
) {
  ENV = 'QA1';
  country = 'CA';
  rootUrl = 'https://qa1-app.inkblotpractice.com';
  apiUrl = 'https://qa1-api.inkblottherapy.com/api';
  serverUrl = 'https://qa1-api.inkblottherapy.com';
  therapyUrl = 'https://qa1-app.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://us-qa1-app.inkblotpractice.com';
  ldClientId = '63c83f0ac6d8f212b950f6bb';
  vonageAppId = '11da5b40-fedb-4894-a7d6-42d72b924dbc';
} else if (hostname === 'us-qa1-app.inkblotpractice.com') {
  ENV = 'QA1 US';
  country = 'US';
  rootUrl = 'https://us-qa1-app.inkblotpractice.com';
  apiUrl = 'https://qa1-api.inkblottherapy.com/api';
  serverUrl = 'https://qa1-api.inkblottherapy.com';
  therapyUrl = 'https://us-qa1-app.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://qa1-app.inkblotpractice.com';
  ldClientId = '63c83f0ac6d8f212b950f6bb';
  vonageAppId = '11da5b40-fedb-4894-a7d6-42d72b924dbc';
} else if (hostname === 'qa2-app.inkblotpractice.com') {
  ENV = 'QA2';
  country = 'CA';
  rootUrl = 'https://qa2-app.inkblotpractice.com';
  apiUrl = 'https://qa2-api.inkblottherapy.com/api';
  serverUrl = 'https://qa2-api.inkblottherapy.com';
  therapyUrl = 'https://qa2-app.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://us-qa2-app.inkblotpractice.com';
  ldClientId = '63c83f0fea045412753297dc';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (hostname === 'us-qa2-app.inkblotpractice.com') {
  ENV = 'QA2 US';
  country = 'US';
  rootUrl = 'https://us-qa2-app.inkblotpractice.com';
  apiUrl = 'https://qa2-api.inkblottherapy.com/api';
  serverUrl = 'https://qa2-api.inkblottherapy.com';
  therapyUrl = 'https://us-qa2-app.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://qa2-app.inkblotpractice.com';
  ldClientId = '63c83f0fea045412753297dc';
  vonageAppId = 'a825d898-cd18-4a72-af96-ebb5a0290fc5';
} else if (hostname === 'practitioner-cat.greenshieldplus.ca') {
  ENV = 'CAT';
  country = 'CA';
  rootUrl = 'https://practitioner-cat.greenshieldplus.ca';
  apiUrl = 'https://api-cat.inkblottherapy.com/api';
  serverUrl = 'https://api-cat.inkblottherapy.com';
  therapyUrl = 'https://app-cat.inkblottherapy.com';
  stripeKey = 'pk_test_5IuQ76s23QQbsEwJQUFPdqUW';
  oppositeCountryURL = 'https://practitioner-cat.inkblotpractice.com';
  ldClientId = '61ba3223f940930e6232e840';
  vonageAppId = '5c879039-3dab-4d2c-9881-330415c2a612';
}

export const ROOT_URL = `${rootUrl}`;
export const API_URL = `${apiUrl}`;
export const SERVER_URL = `${serverUrl}`;
export const THERAPY_URL = `${therapyUrl}`;
export const STRIPE_KEY = `${stripeKey}`;
export const ENVIRONMENT = `${ENV}`;
export const COUNTRY = `${country}`;
export const OTHER_COUNTRY_URL = `${oppositeCountryURL}`;
export const LD_CLIENT_ID = ldClientId;
export const VONAGE_APP_ID = vonageAppId;
